export const checkoutSteps = ['account', 'delivery', 'payment']
